import React from "react";
import SurveyCondensedTable from "../../../SurveyCondensedTable"
import { NumberFormat, PlaceholderFormat, SelectCombosIBS } from "../../../../Enums/constants"
import { observer } from "mobx-react";
import { handleHOTChangeLtdPartnership, LtdPartnershipCellRenderer, renderPrivateEquityTotalRow, handleLtdPartnershipsData } from "./LtdPartnershipTableHandler";
import { getOptionsArray } from "../../../../ibsHelper";

const LtdPartnershipTable = observer((props) => {
    let currencyPlaceHolderMilsForHeader = `|${PlaceholderFormat.CURRENCY_MILS}|`;

    return (
        <SurveyCondensedTable tableName={"PrivateEquity"}
            handleData={handleLtdPartnershipsData}
            handleHOTChange={handleHOTChangeLtdPartnership}
            cellRenderer={LtdPartnershipCellRenderer}
            styleOverride={{ marginTop: '25px', marginBottom: '213px' }}
            headers={["PartnershipName", "PrivateEquityTypeName", "PrivateEquityRegionName", "DataYear", "IsInCommitmentPeriod", "OriginalCommitmentMil", "UnreturnedInvestmentCapMil", "NetAssetValueMil",
                "FeePercentCommitment", "FeePercentInvestedCap", "FeeBasisDuringCommitmentTypeName", "FeeBasisPostCommitmentTypeName", "CarriedInterestPercent", "HurdleRatePercent", "RowID", "del"]}
            columns={[
                { data: 'PartnershipName' },
                { data: 'PrivateEquityTypeName', className: "htLeft", type: 'dropdown', source: ['', 'Diversified', 'LBO', 'Venture Cap.', 'Expansion Cap.', 'Mezzanine', 'Distressed Debt', 'Energy', 'Other', 'Real Estate', 'Infrastructure', 'Timberland', 'Direct Lending'] },
                { data: 'PrivateEquityRegionName', className: "htLeft", type: 'dropdown', source: ['', 'U.S.', 'Canada', 'Europe', 'Asia - Pacific', 'Other', 'Global'] },
                { data: 'DataYear' },
                { data: 'IsInCommitmentPeriod', type: 'dropdown', source: getOptionsArray(SelectCombosIBS.YES_NO) },
                { data: 'OriginalCommitmentMil' },
                { data: 'UnreturnedInvestmentCapMil' },
                { data: 'NetAssetValueMil' },
                { data: 'FeePercentCommitment' },
                { data: 'FeePercentInvestedCap' },
                { data: 'FeeBasisDuringCommitmentTypeName', type: 'dropdown', source: ['', 'Commitment Amount', 'Net Asset Value', 'Book Cost', 'Unreturned Invested Capital', 'Net Operating Income', 'Other'] },
                { data: 'FeeBasisPostCommitmentTypeName', type: 'dropdown', source: ['', 'Commitment Amount', 'Net Asset Value', 'Book Cost', 'Unreturned Invested Capital', 'Net Operating Income', 'Other'] },
                { data: 'CarriedInterestPercent' },
                { data: 'HurdleRatePercent' },
                { data: 'RowID' },
                { data: 'del', className: 'delCol' },

            ]}
            includeTotalRow
            renderTotalRow={renderPrivateEquityTotalRow}
            colWidths={['300px', '120px', '100px', '50px', '50px', '80px', '80px', '80px', '80px', '80px', '180px', '180px', '80px', '80px', '10px', '23px']}
            hiddenColumns={[10, 11]}
            addRowBtnName={"Add Limited Partnership"}
            canDownload={true}
            formatting={['', '', '', '', '', NumberFormat.MONEYMILLION, NumberFormat.MONEYMILLION, NumberFormat.MONEYMILLION,
                NumberFormat.PERCENTAGE, NumberFormat.PERCENTAGE, '', '', NumberFormat.PERCENTAGE, NumberFormat.PERCENTAGE, '', '']}
            nestedHeaders={[
                ['Partnership Name or ID',
                    'Type',
                    'Primary <br/>region',
                    'Vintage <br/>year',
                    'Is it in <br/>commit- <br/>ment <br/>period?',
                    `Original <br/>commitment<br/>(${currencyPlaceHolderMilsForHeader})`,
                    `Unreturned <br/>invested <br/>capital <br/>(${currencyPlaceHolderMilsForHeader})`,
                    `Net Asset <br/>Value <br/>(${currencyPlaceHolderMilsForHeader})`,
                    'Fee % <br/>during <br/>commit- <br/>ment <br/>period',
                    'Fee % <br/>post <br/>commit- <br/>ment <br/>period',
                    'Describe Fee <br/>basis during <br/>commitment <br/>period',
                    'Describe Fee <br/>basis post <br/>commitment <br/>period',
                    "GP's <br/>carried <br/>interest % <br/>",
                    'Hurdle <br/>rate % <br/>'
                ]
            ]}

            helpText={["", "", "", "", "", "",
                "Unreturned invested capital equals contributed capital less contributed capital attributable to realized investments less the aggregate amount of write-downs, if any, with respect to unrealized investments. It is often the amount on which fees are based after the investment period ends.",
                "", "", "Private equity management fees are typically paid as a percentage of the committed amount during the investment period and as a percentage of unreturned invested capital after the investment period ends. Please provide even if it is the same % as the commitment fee.",
                "", "", "Carried interest % is the share of fund return that the General Partner is entitled to if the fund is successful (after catch-up provisions), not what has been actually paid.",
                "Hurdle rate % is the minimum rate of return which must be achieved before the private equity fund manager can receive any carried interest payments. For example, a hurdle rate of 10% means that the private equity fund needs to achieve a return of at least 10% per annum before the profits are shared according to the carried interest arrangement.",
                "", ""
            ]} />
    );

});
export default LtdPartnershipTable;